import { observable, action } from 'mobx'

class Store {
  @observable backgroundColor = '#ffdcc0'

  @action
  updateBackgroundColor = backgroundColor => {
    this.backgroundColor = backgroundColor
  }

  @observable
  visibleSection = {
    hero: true,
    about: false,
  }

  updateVisible = section => {
    this.visibleSection[section] = !this.visibleSection[section]
  }

  @action
  updateHero = bool => {
    this.visibleSection.hero = bool
  }

  @action
  updateAbout = bool => {
    this.visibleSection.about = bool
  }
}

export default new Store()



// WEBPACK FOOTER //
// ./src/store/index.js